import { Link } from 'react-router-dom';
import { Box, Button, Group, IconCopy, IconLock, Token, Tooltip, Typography, Wrapper } from '@screentone/core';

import { usePageLock } from 'contexts/page-lock/usePageLock';
import { AvailableFeatureFlags, PageDto } from 'data/generated/graphql';
import { OKTA_ENV } from 'features/auth/components/OktaRouter';
import { usePublicationSettings } from 'hooks/publication-settings';
import { useFeatureFlag } from 'hooks/useFeatureFlag';
import env from 'utils/env';
import styles from './PagesList.module.scss';

const prod = env.OKTA_ENV === OKTA_ENV.PRD;

interface PageListItemProps {
  page: PageDto;
  to: string;
  baseRoute: string;
  routeKey: string;
  publicationSettings: ReturnType<typeof usePublicationSettings>['data'];
}

export const PageListItem = ({ page, to, baseRoute, routeKey, publicationSettings }: PageListItemProps) => {
  const isPageLockEnabled = useFeatureFlag(AvailableFeatureFlags.PageLockingEnabled, false);
  const { state } = usePageLock();
  const publishingState = state.publishing;

  return (
    <Box padding={{ all: 'sm' }} margin={{ top: 'sm', bottom: 'sm' }} className={styles.pageItem}>
      <Link to={to} aria-label={page.metadata.name} className={styles.pageItemLink} />
      <Wrapper className={styles.pageItemContent}>
        <div className={styles.pageItemLeft}>
          <Typography variant="bodytext" margin={{ right: 'sm' }} data-testid="pages-names-section">
            {page.metadata.name}
          </Typography>
          <Typography margin={{ left: 'sm' }} variant="note">
            {baseRoute}
            {routeKey}
            {!prod && (
              <Button
                className={styles.pageItemAction}
                margin={{ left: 'sm' }}
                tertiary
                icon={IconCopy}
                onClick={() =>
                  navigator.clipboard.writeText(`${publicationSettings?.publicationSetting.baseRoute}${routeKey}`)
                }
              />
            )}
          </Typography>
        </div>
        <Group gap="sm">
          {isPageLockEnabled && publishingState.lockedBy && (
            <Tooltip className={styles.pageItemAction}>
              <Tooltip.Trigger>
                <IconLock size="md" color="asphalt" />
              </Tooltip.Trigger>
              <Tooltip.Content>{publishingState.lockedBy.name}</Tooltip.Content>
            </Tooltip>
          )}
          <Token color="gray">{page.root.attributes.pageType}</Token>
        </Group>
      </Wrapper>
    </Box>
  );
};
